import { jsxs as o, jsx as n } from "react/jsx-runtime";
import { useState as x, useEffect as C } from "react";
import { Container as S, ButtonWrapper as d, Content as y, Text as h, InputWrapper as I, StyledInput as P, Anchor as k } from "./styles.js";
import { Button as v } from "../Button/Button.js";
import { Select as z } from "../Select/Select.js";
const f = (e, r) => Math.floor(e / r + 1), N = (e, r) => Math.ceil(e / r), p = (e, r) => (e - 1) * r, g = [
  {
    value: 25,
    label: 25
  },
  {
    value: 50,
    label: 50
  },
  {
    value: 100,
    label: 100
  }
], T = ({ limit: e, offset: r, total: s, onPaginationChange: u, className: b }) => {
  const [t, i] = x(1), l = N(s, e), a = f(r, e), m = g.find(({ value: c }) => c === e);
  return C(() => {
    i(1);
  }, [e, r, s]), /* @__PURE__ */ o(S, { className: b, children: [
    /* @__PURE__ */ n(d, { $visible: a > 1, children: /* @__PURE__ */ n(
      v,
      {
        appearance: "accent",
        variant: "secondary",
        size: "md",
        onClick: () => {
          a <= 1 || u([a - 1, e, p(a - 1, e)]);
        },
        children: "← Prev"
      }
    ) }),
    /* @__PURE__ */ o(y, { children: [
      /* @__PURE__ */ o(h, { children: [
        "Page ",
        a,
        " of ",
        l || 1,
        ". Jump to page"
      ] }),
      /* @__PURE__ */ n(I, { children: /* @__PURE__ */ n(
        P,
        {
          "aria-label": "page number",
          type: "number",
          min: "1",
          error: !t || l < t,
          max: `${l}`,
          value: t.toString(),
          onChange: (c) => {
            i(parseInt(c.currentTarget.value, 10));
          }
        }
      ) }),
      /* @__PURE__ */ n(
        k,
        {
          onClick: () => {
            !t || t > l || t === a || u([t, e, p(t, e)]);
          },
          children: "Go"
        }
      ),
      /* @__PURE__ */ n(h, { children: "Show per page" }),
      /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(
        z,
        {
          "aria-label": "page size",
          isSearchable: !1,
          value: m,
          options: g,
          onChange: (c) => {
            c !== null && u([f(r, c.value), c.value, r]);
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ n(d, { $visible: a < l, children: /* @__PURE__ */ n(
      v,
      {
        appearance: "accent",
        variant: "secondary",
        size: "md",
        onClick: () => {
          a + 1 > l || u([a + 1, e, p(a + 1, e)]);
        },
        children: "Next →"
      }
    ) })
  ] });
};
T.displayName = "Pagination";
export {
  T as Pagination
};
//# sourceMappingURL=Pagination.js.map
